<template>
  <v-layout wrap>
    <v-flex
      xs12
      md6
      class="form-left-column"
    >
      <v-text-field
        v-model="form.values.name"
        :error-messages="getRequiredErrors(form.errors.name)"
        :label="$t('pets.form.name')"
      />
      <v-autocomplete
        v-model="form.values.species"
        :error-messages="getRequiredErrors(form.errors.species)"
        :items="speciesList"
        :no-data-text="$t('messages.noDataAvailable')"
        item-text="name"
        item-value="id"
        :label="$t('pets.form.species')"
        @change="onSpeciesChange(form.values.species)"
      />
      <v-autocomplete
        v-model="form.values.race"
        :error-messages="getRequiredErrors(form.errors.race)"
        :items="raceList"
        :no-data-text="$t('messages.noDataAvailable')"
        item-text="name"
        item-value="id"
        :label="$t('pets.form.race')"
      />
      <v-autocomplete
        v-model="form.values.sex"
        :error-messages="getRequiredErrors(form.errors.sex)"
        :items="sexes"
        :no-data-text="$t('messages.noDataAvailable')"
        item-text="name"
        item-value="id"
        :label="$t('pets.form.sex')"
      />
    </v-flex>
    <v-spacer />
    <v-flex
      xs12
      md6
      class="form-right-column"
    >
      <v-text-field
        v-model="form.values.birthDate"
        :error-messages="getRequiredErrors(form.errors.birthDate)"
        :label="$t('pets.form.birthDate')"
        type="date"
      />
      <v-text-field
        v-model="form.values.weight"
        :error-messages="getRequiredErrors(form.errors.weight)"
        :label="$t('pets.form.weight')"
        type="number"
        :suffix="$t('pets.form.weightSuffix')"
      />
      <v-text-field
        v-model="form.values.microchip"
        :error-messages="getMinLengthErrors(form.errors.microchip)"
        :label="$t('pets.form.microchip')"
      />
      <v-text-field
        v-model="form.values.passport"
        :label="$t('pets.form.passport')"
      />
      <v-checkbox
        v-model="form.values.sterilized"
        :label="checkboxLabel"
        color="primary"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  SPECIES_LIST_KEY,
  RACE_LIST_KEY,
} from '../../store/types/pets.types'
import { sexes } from '../../config'

export default {
  name: 'PetsFormFields',
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sexes,
    }
  },
  computed: {
    checkboxLabel() {
      return `${this.$t('pets.form.castrated')}/${this.$t('pets.form.sterilized')}`
    },
    ...mapState({
      speciesList: state => state.pets[SPECIES_LIST_KEY],
      raceList: state => state.pets[RACE_LIST_KEY],
    }),
  },
  methods: {
    onSpeciesChange(species) {
      if (typeof species !== 'undefined') this.$emit('getRaces', species)
    },
    getRequiredErrors(values = {}) {
      const errors = []
      if (values.required) errors.push(this.$t('validates.requiredField'))
      return errors
    },
    getMinLengthErrors(values = {}) {
      const errors = []
      if (values.minLength || values.maxLength) errors.push(this.$t('validates.minLength'))
      return errors
    },
  },
}
</script>

<style lang="stylus" scoped>
@media only screen and (min-width: 960px)  {
  .form-left-column {
    padding-right: 20px !important;
  }
  .form-right-column {
    padding-left: 20px !important;
  }
}
</style>
